module.exports = __webpack_public_path__ + "static/media/rome-12.7d8cc117.jpg";